// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap, default-param-last, prefer-destructuring */
import { Map } from "immutable"
import type { Dispatch } from "redux"
// @ts-expect-error: Flow to TS migration.
import { createSelector, OutputSelector, InputSelector } from "reselect"
import R from "ramda"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"
import { bidSelector, ancillariesSelector } from "@kiwicom/frontend-common/services/booking/booking"
import type { Ancillaries } from "@kiwicom/frontend-common/types/bookingAncillary"
import Price from "@kiwicom/frontend-common/records/Price"
import type { PassengerId } from "@kiwicom/frontend-common/types/primitiveTypes"
import type { BookingId } from "@kiwicom/frontend-common/types/booking"

import {
  fetchThirdPartyAncillaries,
  fetchThirdPartyAncillariesOffers,
} from "../../../../../../../services/bookings/bookingsApi"
import type {
  AncillariesPassengerOffers,
  AncillaryAxaOffer,
  AxaInsuranceAncillaries,
  AxaInsuranceOffer,
} from "../consts/types"

// @ts-expect-error: Flow to TS migration.
type State = Map<{
  loading: boolean
  ancillaries: Ancillaries
  offers: AncillariesPassengerOffers
}>
type GetState = () => State

// CONSTANTS
const LOAD_ANCILLARIES = "ancillaries/LOAD_ANCILLARIES"
const LOAD_ANCILLARIES_SUCCESS = "ancillaries/LOAD_ANCILLARIES_SUCCESS"
const LOAD_ANCILLARIES_FAILURE = "ancillaries/LOAD_ANCILLARIES_FAILURE"
const LOAD_ANCILLARIES_REQUEST = "ancillaries/LOAD_ANCILLARIES_REQUEST"

const LOAD_ANCILLARIES_OFFERS = "ancillaries/LOAD_ANCILLARIES_OFFERS"
const LOAD_ANCILLARIES_OFFERS_SUCCESS = "ancillaries/LOAD_ANCILLARIES_OFFERS_SUCCESS"
const LOAD_ANCILLARIES_OFFERS_FAILURE = "ancillaries/LOAD_ANCILLARIES_OFFERS_FAILURE"
const LOAD_ANCILLARIES_OFFERS_REQUEST = "ancillaries/LOAD_ANCILLARIES_OFFERS_REQUEST"

// REDUCER’s INITIAL STATE
export const INITIAL_STATE = Map({
  loading: false,
  error: false,
  // ordered ancillaries
  ancillaries: {
    usCoverMoreInsurance: null,
    axa: [],
    axaUsInsurance: null,
  },
  offers: {
    axa: null,
    axaUsInsurance: null,
  },
})

// REDUCER
export default function ancillariesReducer(
  state: State | null | undefined = INITIAL_STATE,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any,
) {
  switch (action.type) {
    case LOAD_ANCILLARIES_REQUEST:
    case LOAD_ANCILLARIES_OFFERS_REQUEST:
      return state.set("loading", true)
    case LOAD_ANCILLARIES_SUCCESS:
      return state.set("ancillaries", action.res).set("loading", false)
    case LOAD_ANCILLARIES_OFFERS_SUCCESS:
      return state.set("offers", action.res).set("loading", false)
    case LOAD_ANCILLARIES_FAILURE:
    case LOAD_ANCILLARIES_OFFERS_FAILURE:
      return state.set("loading", false).set("error", true)
    default:
      return state
  }
}

// SELECTORS
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ancillariesLoadingSelector: any = (state: any) => state.ancillaries.get("loading")

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ancillariesErrorSelector: any = (state: any) => state.ancillaries.get("error")

// THUNKS
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadAncillaries = () => async (dispatch: Dispatch<any>, getState: GetState) => {
  const state = getState()
  const bid = bidSelector(state)
  const promise = fetchThirdPartyAncillaries(bid)

  // Dispatch action
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/await-thenable
  const ok = await dispatch({
    type: LOAD_ANCILLARIES,
    promise,
    _track: { bid },
  })

  // Track ancillaries error
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!ok) {
    // @ts-expect-error: Flow to TS migration.
    cuckoo.track(cuckooEvents.MMB_ANCILLARIES_ERROR_XHR)
  }

  return ok
}

// Backend sends two options: "basic" and "plus", we also need to provide
// possibility to select "none" as an option
const appendNoneInsuranceOffer = (offers: AncillariesPassengerOffers) => {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!offers) return null

  return {
    // Spread so that other services are left intact
    ...offers,
    // Override AXA property to append "none" to each offer
    axa:
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/prefer-optional-chain
      offers.axa &&
      offers.axa.map((papOffers) => {
        if (papOffers.options.length === 0) return papOffers

        return papOffers.options.reduce(
          (offerOptions, curr) => {
            const optionName = Object.keys(curr)[0]
            // @ts-expect-error: Flow to TS migration.
            const offerPrice = curr[optionName]

            return {
              ...offerOptions,
              passengerId: papOffers.passengerId,
              options: {
                ...offerOptions.options,
                [optionName]: offerPrice,
              },
            }
          },
          // Append none
          { options: { none: new Price({ amount: 0 }) } },
        )
      }),
  }
}

// Axa
export const axaAncillarySelector: InputSelector<
  State,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  AxaInsuranceAncillaries
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
> = createSelector(ancillariesSelector, (ancillaries) => (ancillaries && ancillaries.axa) || [])

/**
 * @param pid
 * @returns active insurance for specific passenger
 */
export const axaInsurancePassengerSelector = (
  pid: PassengerId,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): OutputSelector<State, any, AxaInsuranceOffer> =>
  // @ts-expect-error: Flow to TS migration.
  createSelector(axaAncillarySelector, (axaOrders) => {
    const papInsuranceNone: AxaInsuranceOffer = {
      price: new Price({ amount: 0 }),
      level: "none",
    }

    if (R.isNil(axaOrders) || R.isEmpty(axaOrders)) return papInsuranceNone

    // @ts-expect-error: Flow to TS migration.
    return axaOrders.reduce((acc, curr) => {
      // @ts-expect-error: Flow to TS migration.
      const order = curr.items.find((item) => {
        return item.isActive && item.id === pid
      })

      return order || acc
    }, papInsuranceNone)
  })

// Offers
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ancillariesOffersSelector: InputSelector<State, any, AncillariesPassengerOffers> = (
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state: any,
) => state.ancillaries.get("offers")

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ancillaryAxaInsuranceOffersSelector: any = createSelector(
  ancillariesOffersSelector,
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  (offers) => offers && offers.axa,
)

const reduceToLowestOffer = (lowestOffer: number, offer: AncillaryAxaOffer): number => {
  // @ts-expect-error: Flow to TS migration.
  const lowestPaxOffer = R.compose(
    R.reduce(R.min, lowestOffer),
    // @ts-expect-error: Flow to TS migration.
    R.map((price) => price.amount),
    R.values,
    R.omit(["none"]),
  )(offer.options)

  // @ts-expect-error: Flow to TS migration.
  return lowestPaxOffer
}

export const ancillaryAxaInsuranceLowestOfferSelector: InputSelector<
  State,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  number
> = createSelector(ancillaryAxaInsuranceOffersSelector, (paxOffers) => {
  // @ts-expect-error: Flow to TS migration.
  const minPrice = paxOffers?.reduce(reduceToLowestOffer, Infinity)

  return minPrice === Infinity ? 0 : minPrice
})

export const loadAncillariesApiOffers = (bid: BookingId) => ({
  type: LOAD_ANCILLARIES_OFFERS,
  promise: fetchThirdPartyAncillariesOffers(bid, appendNoneInsuranceOffer),
  _track: { bid },
})
